/**
 * Javascript file for the example canvas page.
 * @author Adrian Rebmann, Michael Frey
 */

export default {
  name: "ExampleCanvas",
  props: ["bmname"],

  /**
   * The vue instance's data object.
   * @property {object} values - The canvas' values.
   * @property {string} vp - The company's value propositions.
   * @property {string} ka - The company's key activities.
   * @property {string} kp - The company's key partners.
   * @property {string} cr - The company's customer relationships.
   * @property {string} cs - The company's customer segments.
   * @property {string} ch - The company's channels.
   * @property {string} kr - The company's key resources.
   * @property {string} cS - The company's cost structure.
   * @property {string} rS - The company's sources of income.
   * @property {string} description - The company's description.
   */
  data: () => ({
    values: { name: "" },
    vp: "",
    ka: "",
    kp: "",
    cr: "",
    cs: "",
    ch: "",
    kr: "",
    cS: "",
    rS: "",
    description: ""
  }),

  /**
   * Called after the instance has been created.
   */
  created() {
    const json = require("../../../../../../static/" + this.bmname + ".json");
    this.vp = json.vp;
    this.ka = json.ka;
    this.kp = json.kp;
    this.cr = json.cr;
    this.cs = json.cs;
    this.ch = json.ch;
    this.kr = json.kr;
    this.cS = json.cS;
    this.rS = json.rS;
    this.description = json.description;
  }
};



// WEBPACK FOOTER //
// ./src/components/company/businessmodel/example/canvas/examplecanvas.js